import { apiService } from './api';
import {
  RegistryNode,
  RegistryWorkflow,
  RegistryListResponse,
  PushNodeRequest,
  PushWorkflowRequest,
  InstallNodeRequest,
  InstallWorkflowRequest,
} from '../types/registry.types';

const BASE = '/registry';

export const registryService = {
  // ── Nodes ──────────────────────────────────────────────────────────────
  getNodes: (params?: {
    q?: string;
    category?: string;
    status?: string;
    is_trigger?: boolean;
  }): Promise<RegistryListResponse<RegistryNode>> =>
    apiService.get(`${BASE}/nodes/`, params as Record<string, unknown>),

  getNode: (id: string): Promise<RegistryNode> =>
    apiService.get(`${BASE}/nodes/${id}/`),

  getNodeCategories: (): Promise<string[]> =>
    apiService.get(`${BASE}/nodes/categories/`),

  pushNode: (data: PushNodeRequest): Promise<RegistryNode> =>
    apiService.post(`${BASE}/nodes/push/`, data),

  installNode: (id: string, data?: InstallNodeRequest): Promise<{ id: string; node_type: string; installed: boolean; created: boolean }> =>
    apiService.post(`${BASE}/nodes/${id}/install/`, data ?? {}),

  markNodeOfficial: (id: string): Promise<{ marked_official: boolean }> =>
    apiService.post(`${BASE}/nodes/${id}/mark-official/`, {}),

  // ── Workflows ──────────────────────────────────────────────────────────
  getWorkflows: (params?: {
    q?: string;
    category?: string;
    status?: string;
  }): Promise<RegistryListResponse<RegistryWorkflow>> =>
    apiService.get(`${BASE}/workflows/`, params as Record<string, unknown>),

  getWorkflow: (id: string): Promise<RegistryWorkflow> =>
    apiService.get(`${BASE}/workflows/${id}/`),

  getWorkflowCategories: (): Promise<string[]> =>
    apiService.get(`${BASE}/workflows/categories/`),

  pushWorkflow: (data: PushWorkflowRequest): Promise<RegistryWorkflow> =>
    apiService.post(`${BASE}/workflows/push/`, data),

  installWorkflow: (id: string, data?: InstallWorkflowRequest): Promise<{ workflow_id: string; name: string; node_count: number; installed: boolean }> =>
    apiService.post(`${BASE}/workflows/${id}/install/`, data ?? {}),

  markWorkflowOfficial: (id: string): Promise<{ marked_official: boolean }> =>
    apiService.post(`${BASE}/workflows/${id}/mark-official/`, {}),

  // ── Admin ──────────────────────────────────────────────────────────────
  seedBuiltins: (): Promise<{ seeded: boolean; total: number; created: number; updated: number }> =>
    apiService.post(`${BASE}/nodes/seed-builtins/`, {}),
};
